import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import SharedHeader from './Header';
import SharedFooter from './Footer';
import ClientPanelLayout from './ClientPanelLayout';

// Post-login Client Panel Pages
import OrderTrackerPage from '../pages/OrderTracker/OrderTrackerPage';
import ClientDashboardPage from '../pages/Dashboard/ClientDashboardPage';
import InquiriesPage from '../pages/FollowUps/InquiriesPage';
import ReqSamplesPage from '../pages/FollowUps/ReqSamplesPage';
import QuotationsPage from '../pages/FollowUps/QuotationsPage';
import ClientProfilePage from '../pages/ClientProfilePage';
import ClientHomePage from '../pages/home';

// Auth Pages
import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';

import { useSelector } from 'react-redux';
import { RootState } from '../store';

function PublicLayout({ children }: { children: React.ReactElement }) {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
      <SharedHeader title="CLIENT PORTAL" />
      <Box component="main" sx={{ flex: 1 }}>
        {children}
      </Box>
      <SharedFooter />
    </Box>
  );
}

function PrivateRoute({ children }: { children: React.ReactElement }) {
  const authState = useSelector((state: RootState) => state.auth);
  const cookieMatch =
    document.cookie.match(/(?:^|; )buyer_token=([^;]*)/) ||
    document.cookie.match(/(?:^|; )public_private_token=([^;]*)/);
  const cookieToken = cookieMatch ? decodeURIComponent(cookieMatch[1]) : null;
  const token =
    cookieToken ||
    localStorage.getItem('buyer_token') ||
    localStorage.getItem('public_private_token') ||
    sessionStorage.getItem('buyer_token') ||
    sessionStorage.getItem('public_private_token');

  const isLoggedIn =
    Boolean(token && token !== 'null' && token !== 'undefined' && token !== 'false') ||
    authState.isAuthenticated;

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

export function AppContainer() {
  return (
    <Routes>
      {/* Public Authentication Routes */}
      <Route
        path="/login"
        element={
          <PublicLayout>
            <LoginPage />
          </PublicLayout>
        }
      />
      <Route
        path="/register"
        element={
          <PublicLayout>
            <RegisterPage />
          </PublicLayout>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <PublicLayout>
            <ForgotPasswordPage />
          </PublicLayout>
        }
      />
      <Route
        path="/home"
        element={
          <PublicLayout>
            <ClientHomePage />
          </PublicLayout>
        }
      />

      {/* Client Post-Login Panel (Implements the layout from user sketch) */}
      <Route element={<ClientPanelLayout />}>
        {/* Default route lands directly on the requested Order Tracker */}
        <Route path="/" element={<Navigate to="/order-tracker" replace />} />
        <Route path="/order-tracker" element={<OrderTrackerPage />} />
        <Route path="/dashboard" element={<ClientDashboardPage />} />

        {/* Follow-Ups Sub-Menus */}
        <Route path="/follow-ups/inquiries" element={<InquiriesPage />} />
        <Route path="/follow-ups/req-samples" element={<ReqSamplesPage />} />
        <Route path="/follow-ups/quotations" element={<QuotationsPage />} />

        {/* Profile */}
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ClientProfilePage />
            </PrivateRoute>
          }
        />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/order-tracker" replace />} />
    </Routes>
  );
}

export default AppContainer;